<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="name" placeholder="级别名称"></el-input>
                        <el-select v-model="type" placeholder="类型">
                            <el-option label="全部" value=""> </el-option>
                            <el-option label="平面设计师" value="GRAPHIC"> </el-option>
                            <el-option label="三维设计师" value="MODEL"> </el-option>
                        </el-select>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" @click="designLevelDetail('add',0)"><i
                                    class="el-icon-circle-plus-outline"></i>添加
                                </el-button>
                            </div>
                        </div>
                        <div class="orderListTable">
                            <el-table
                                :data="designerLevelList"
                                border
                                style="width: 100%" class="tableContent">
                                <el-table-column
                                    prop="name"
                                    label="级别名称"
                                    header-align="center"
                                    width="200"
                                    show-overflow-tooltip
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="typeCn"
                                    label="类型"
                                    header-align="center"
                                    width="200"
                                    show-overflow-tooltip
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="modelNum"
                                    label="所需模型/作品量"
                                    header-align="center"
                                    show-overflow-tooltip
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="demandNum"
                                    label="所需需求成交量"
                                    header-align="center"
                                    show-overflow-tooltip
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="discountPer"
                                    label="图标"
                                    header-align="center"
                                    show-overflow-tooltip
                                    align="center">
                                    <template slot-scope="scope">
                                        <img :src="scope.row.levelIconUrl" alt="" style="width:30px;height: 30px"/>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="操作"
                                    header-align="center"
                                    align="center"
                                    width="230">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="designLevelDetail('edit',scope.row.uuid)">编辑</el-button>
                                        <el-button type="text" size="small" @click="deleteLevel(scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <invoice-dialog ref="dialogRef"></invoice-dialog>
    </div>
</template>

<script>

    import {
        deleteLevel, designerLevelListByPage
    } from "../../utils/interface";
    import invoiceDialog from './designerLevelDialog/designerLevelDialog'

    export default {
        components: {
            invoiceDialog
        },
        data() {
            return {
                name: '',
                type: null,
                tableData: [],
                designerLevelList: [],
                current: 1,
                pageSize: 10,
                total: 0
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {
            this.getList();
        },
        methods: {
            resetData() {
                this.name = '';
                this.type = null;
                this.search();
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
                this.getList();
            },
            search() {
                this.current = 1
                this.getList();
            },
            getList() {
                this.loading = true
                let params = {
                    levelName: this.name,
                    type:this.type,
                    current: this.current,
                    pageSize: this.pageSize
                };
                designerLevelListByPage(params).then((res) => {
                    if (res.list != null) {
                        this.designerLevelList = res.list;
                        this.loading = false
                        this.pageSize = res.pageSize;
                        this.total = res.total;
                        this.pageNo = res.current;
                    } else {
                        this.loading = false
                    }
                });
            },
            // 新增/修改
            designLevelDetail(type, uuid) {
                this.$refs.dialogRef.init(type, uuid);
            },
            //删除
            deleteLevel(item) {

                this.$confirm('确定删除数据吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return deleteLevel(item);
                }).then(() => {
                    this.$message.success("删除成功");
                    this.getList();
                }).catch(function() {
                    this.$message.error("删除失败");
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;

        .orderManagementContent {
            background: #fff;

            .printOrderListBox {
                padding: 20px;

                .orderSearchBox {
                    .timeSearch {
                        background-color: #f2f4f7;
                        height: 35px;
                        display: flex;
                        align-items: center;
                        margin-bottom: 22px;
                        margin-right: 30px;
                        border-radius: 8px;

                        span {
                            font-size: 12px;
                            color: #c0c4cc !important;
                            font-weight: normal;
                            padding-left: 15px;
                            margin-right: 5px;
                        }

                        // /deep/ .el-range-input{
                        //         background-color: #f2f4f7;
                        //             &:hover, &:focus {
                        //             background-color: #fff;
                        //             // border: 1px solid #108EE9;
                        //         }
                        // }
                        /deep/ input::-webkit-input-placeholder {
                            color: #c0c4cc;
                            font-size: 12px;
                        }

                        /deep/ .el-range-input:hover {
                            background-color: #fff !important;
                        }

                        /deep/ .el-date-editor .el-range-separator {
                            line-height: 25px;
                            color: #c0c4cc;
                        }

                        /deep/ .el-date-editor .el-range__close-icon {
                            line-height: 28px;
                        }

                        /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                            background-color: white;
                        }

                        /deep/ .el-input__inner {
                            width: 225px;
                            height: 35px;
                            min-height: 35px;
                            font-size: 12px;
                            color: #999999;
                            background-color: #f2f4f7;
                            border: 1px solid #f2f4f7;
                            border-radius: 5px;

                            .el-range-input {
                                background-color: #f2f4f7;
                            }

                            &:hover, &:focus {
                                background-color: #fff;
                                border: 1px solid #108EE9;

                            }
                        }
                    }
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover, &:focus {
                            background-color: #fff;
                            border: 1px solid #108EE9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #FFFFFF;
                        margin-bottom:22px;
                    }

                    .resetBtn {
                        color: #333333;
                        margin-bottom:22px;
                    }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }

        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;

            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }

        .orderListTable {
            .orderNomesaage {
                color: #888;
                text-align: center;
                padding: 15px 0;
            }
            .tableHeader {
                display: flex;
                width: 100%;
                height: 35px;
                line-height: 35px;
                background: #f3f7ff;
                border-radius: 5px;
                margin: 0 0 15px;
                li {
                    text-align: center;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }
            }

            .tableBody {
                li {
                    width: 100%;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;
                    margin-bottom: 16px;

                    .itemTop {
                        width: 100%;
                        height: 42px;
                        background: #ebf3fb;
                        line-height: 42px;
                        font-size: 14px;
                        color: #333;
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        position: relative;

                        div {
                            margin-right: 30px;
                        }

                        .merchantInfo {
                            display: flex;
                            align-items: center;

                            i {
                                color: #3d7fff;
                                font-size: 25px;
                                cursor: pointer;
                                padding-left: 5px;
                                display: block;
                            }

                            img {
                                display: block;
                                padding-right: 5px;
                            }
                        }

                        .complainBtn {
                            color: #999;
                            position: absolute;
                            right: 20px;
                        }
                    }

                    .itemBottom {
                        display: flex;
                        align-items: center;
                        color: #333;
                        font-size: 13px;

                        .orderInfo {
                            padding: 20px;
                            display: flex;

                            img {
                                display: block;
                                width: 100px;
                                height: 100px;
                                border-radius: 10px;
                                margin-right: 30px;
                            }

                            .infoContent {
                                .infoName {
                                    font-size: 14px;
                                    color: #000000;
                                    padding-bottom: 10px;
                                }

                                .infoOther {
                                    font-size: 13px;
                                    color: #999999;
                                    padding-bottom: 2px;
                                    -webkit-line-clamp: 3;
                                    -webkit-box-orient: vertical;
                                    display: -webkit-box;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                }
                            }
                        }

                        .designer {
                            padding: 20px;
                        }

                        .designerName {
                            padding-bottom: 8px;
                            img {
                                width: 30px;
                                height: 30px;
                                border-radius: 50%;
                            }
                        }
                        .status {
                            font-size: 14px;
                        }
                        .operationBtn {
                            display: block;
                            color: #0c75d3;
                            text-align: center;
                            margin: 0;
                        }
                    }
                }
            }

            .name {
                width: 200px;
                text-align: center;
            }

            .type {
                width: 200px;
                text-align: center;
            }

            /*.commissionRate {*/
            /*    width: 200px;*/
            /*    text-align: center;*/
            /*}*/

            .modelNum {
                width: 200px;
                text-align: center;
            }
            .demandNum {
                width: 200px;
                text-align: center;
            }
            .levelIconUrl {
                width: 200px;
                text-align: center;
            }
            .buttoncz{
                width: 200px;
                text-align: center;
            }
            .designer {
                width: 95px;
                text-align: center;
            }
            .arguments {
                width: 294px;
            }

            .offer {
                width: 162px;
                text-align: center;
            }
            .expect {
                width: 162px;
                text-align: center;
            }
            .status {
                width: 124px;
                text-align: center;
            }
            .operation {
                width: 124px;
                text-align: center;
                .operationUploadBtn{
                    width: 102px !important;
                    height: 34px;
                    padding: 0;
                    line-height: 34px;
                    text-align: center;
                    font-weight: 700;
                    color: rgba(0, 102, 204, 0.8);
                    font-size: 14px;
                    border-color: rgba(0, 102, 204, 0.8);
                    display: block;
                    margin: 0 auto 10px !important;
                }
            }
        }
        .dialogBox {
            .details {
                .detailsItem {
                    padding-bottom: 20px;

                    h3 {
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }

                    .itemContent {
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;

                        .one-row {
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;

                            .label {
                                padding-right: 15px;
                                min-width: 95px;
                            }

                            .name {
                                color: #000;
                            }
                        }

                        .two-row {
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;

                            .label {
                                padding-right: 15px;
                                min-width: 95px;
                            }

                            .name {
                                color: #000;
                            }
                        }
                    }

                    .itemPictureContent {
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;

                        .one-row {
                            width: 30%;
                            margin-bottom: 22px;

                            img {
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }

                            .name {
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;

                                .label {
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }

            .audit {
                padding-bottom: 20px;

                h3 {
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }

                .auditContent {
                    padding: 0 30px;
                }

                .cause {
                    display: flex;
                    margin-top: 20px;

                    .causeTitle {
                        min-width: 80px;
                        color: #3a8ee6;
                    }

                    .causeContent {
                        color: #000;
                    }
                }

                .auditEnter {
                    text-align: center;
                    padding-top: 20px;

                    button {
                        width: 120px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/designerLevelManager/designerLevelList.vue